<template>
  <v-container fluid>
    <v-row data-app>
      <v-col xs="12" md="5" class="office-controls pt-0">
          <office-tree-view @node-selected="onNodeSelected" :id="officeId"></office-tree-view>
      </v-col>
      <v-col xs="12" md="7" class="office-details">
        <div class="details-view-container elevation-2">
          <office-details-view :info="nodeInfo" class="fade-in"></office-details-view>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from "@/router";
import { CONSTANTS } from "@/common/constants";
import { authTokenService } from "@/services/authTokenService.js";
import { officeManagementService } from "@/services/officeManagementService.js";

export default {
  name: "AdminOfficeDetails",
  props: {
    id: null
  },
  data: () => ({
    nodeInfo: null,
    officeId: null
  }),
  methods: {
    onNodeSelected (evt) {
      this.nodeInfo = { officeId: evt.id, surveyId: evt.surveyId };
    }
  },
  mounted () {
    this.officeId = (!this.$route.params.id) ? -1 : this.$route.params.id;
    this.surveyId = (!this.$route.params.surveyId) ? -1 : this.$route.params.surveyId;
  }
};
</script>

<style scoped>

.office-controls {
  /* border-right: 5px solid gray; */
  /* border-color: #bbc8e0 BETTER COLOR */
  /* background-color: lightblue; */
  /* margin-right: 10px; */
  padding: 10px;
}

.office-details {
  padding: 0 15px;
}

.details-view-container {
    background-color: ghostwhite;
    border: 1px solid lightgray;
    padding: 15px;
}

</style>
